import {Settings} from './interfaces';

export const SETTINGS: Settings = {
  STARTING_RESOURCES: {
    food: 500,
    wood: 10,
    population: 5,
    stone: 0,
    metal: 0,
    gold: 0,
    power: 0,
    data: 5,
    acres: 5,
    baseAcres: 5,
    freeAcres: 3,
  },
  POPULATION: {
    MAX_EFFICIENCY: 1,
  },
  EXPLORATION: {
    COSTS: {
      food: 35,
    },
    COST_MULTIPLIER: 5,
  },
  BUILDING_SETTINGS: {
    HOUSE: {
      STARTING_AMOUNT: 1,
      JOBS: 0,
      COSTS: {
        food: 20,
        wood: 5,
        freeAcres: 1,
      },
      PRODUCTION: {
        food: 600,
      }
    },
    FARM: {
      STARTING_AMOUNT: 1,
      JOBS: 1,
      COSTS: {
        wood: 10,
        freeAcres: 1,
      },
      PRODUCTION: {
        food: 60,
      }
    },
    FORESTER: {
      STARTING_AMOUNT: 0,
      JOBS: 1,
      COSTS: {
        food: 50,
        freeAcres: 1,
      },
      PRODUCTION: {
        wood: 10,
      }
    },
    MASONRY: {
      STARTING_AMOUNT: 0,
      JOBS: 3,
      COSTS: {
        food: 50,
        wood: 10,
        freeAcres: 1,
      },
      PRODUCTION: {
        stone: 10,
      }
    },
    FOUNDRY: {
      STARTING_AMOUNT: 0,
      JOBS: 5,
      COSTS: {
        food: 100,
        stone: 100,
        wood: 100,
        freeAcres: 1,
      },
      PRODUCTION: {
        metal: 8,
      }
    },
    GOLDSMITH: {
      STARTING_AMOUNT: 0,
      JOBS: 10,
      COSTS: {
        food: 100,
        stone: 100,
        wood: 100,
        metal: 100,
        freeAcres: 1,
      },
      PRODUCTION: {
        gold: 5,
      }
    },
    POWER_PLANT: {
      STARTING_AMOUNT: 0,
      JOBS: 25,
      COSTS: {
        food: 250,
        stone: 100,
        wood: 200,
        metal: 50,
        gold: 40,
        freeAcres: 2,
      },
      PRODUCTION: {
        power: 25,
      }
    },
    DATA_CENTER: {
      STARTING_AMOUNT: 0,
      JOBS: 100,
      COSTS: {
        food: 15000,
        stone: 2000,
        wood: 4000,
        metal: 2000,
        gold: 2000,
        data: 5,
        freeAcres: 5,
      },
      PRODUCTION: {
        data: .2,
      }
    },
  }
};

export let OWNED_BUILDINGS: any = {};

export const TECHNOLOGY = {
  stone_age: {
    name: 'Stone Age',
    desciption: 'Unlocks technology',
    costs: {},
    building_requirements: {
      house: 1,
      farm: 1,
      forester: 1,
    },
    tech_requirements: [],
  },
  cultivation: {
    name: 'Cultivation',
    desciption: '+10% F',
    costs: {
      food: 20,
    },
    building_requirements: {},
    tech_requirements: ['stone_age'],
  },
  growing: {
    name: 'Growing',
    desciption: '+10% F',
    costs: {
      food: 30,
      wood: 5,
    },
    building_requirements: {},
    tech_requirements: ['cultivation'],
  },
  tools: {
    name: 'Tools',
    desciption: '+10% W',
    costs: {
      food: 30,
      wood: 10,
    },
    building_requirements: {},
    tech_requirements: ['stone_age'],
  },
  woodwork: {
    name: 'Woodwork',
    desciption: '+20% W',
    costs: {
      food: 50,
      wood: 15,
    },
    building_requirements: {
      forester: 5,
    },
    tech_requirements: ['tools'],
  },
  wheel: {
    name: 'Wheel',
    desciption: 'Xlpr -5%',
    costs: {
      food: 20,
      wood: 30,
    },
    building_requirements: {},
    tech_requirements: ['tools'],
  },
  wheelbarrow: {
    name: 'Wheelbarrow',
    desciption: '+10% F / +10% W',
    costs: {
      food: 100,
      wood: 20,
    },
    building_requirements: {},
    tech_requirements: ['wheel'],
  },
  bronze_age: {
    name: 'Bronze Age',
    desciption: 'Unlocks new technology',
    costs: {
      food: 500,
      wood: 200,
    },
    building_requirements: {
      house: 5,
    },
    tech_requirements: ['wheelbarrow', 'growing'],
  },
  agriculture: {
    name: 'Agriculture',
    desciption: '+20% F',
    costs: {
      food: 200,
    },
    building_requirements: {
      farm: 5,
    },
    tech_requirements: ['growing'],
  },
  irrigation: {
    name: 'Irrigation',
    desciption: '+15% F',
    costs: {
      food: 100,
      wood: 50,
    },
    building_requirements: {},
    tech_requirements: ['agriculture', 'bronze_age'],
  },
  masonry: {
    name: 'Masonry',
    desciption: 'Unlocks stone',
    costs: {
      food: 300,
      wood: 100,
    },
    building_requirements: {},
    tech_requirements: ['bronze_age'],
  },
  brick_house: {
    name: 'Brick houses',
    desciption: 'Upgrade house +2 pop',
    costs: {
      food: 1000,
      stone: 30,
    },
    building_requirements: {},
    tech_requirements: ['masonry'],
  },
  paths: {
    name: 'Paths',
    desciption: 'Decrease exploration costs -5%',
    costs: {
      food: 500,
      wood: 50,
    },
    building_requirements: {},
    tech_requirements: ['masonry'],
  },
  oven: {
    name: 'Oven',
    desciption: '+5% W / +5% F',
    costs: {
      food: 100,
      wood: 50,
      stone: 50,
    },
    building_requirements: {},
    tech_requirements: ['masonry'],
  },
  roman_age: {
    name: 'Roman Age',
    desciption: 'Unlocks roman age technology',
    costs: {
      food: 2000,
      wood: 500,
      stone: 150,
    },
    building_requirements: {
      masonry: 5,
    },
    tech_requirements: ['brick_house', 'paths'],
  },
  stone_roads: {
    name: 'Stone roads',
    desciption: 'Reduces exploration costs -10%',
    costs: {
      food: 300,
      wood: 50,
      stone: 100,
    },
    building_requirements: {},
    tech_requirements: ['roman_age'],
  },
  teaching: {
    name: 'Teaching',
    desciption: 'Unlocks technology',
    costs: {
      food: 2500,
    },
    building_requirements: {},
    tech_requirements: ['roman_age'],
  },
  philosophy: {
    name: 'Philosophy',
    desciption: 'Increase population +1 housing',
    costs: {
      food: 1000,
      wood: 100,
      stone: 100,
    },
    building_requirements: {},
    tech_requirements: ['teaching'],
  },
  sculpture: {
    name: 'Sculpture',
    desciption: 'Increase stone production +5%',
    costs: {
      food: 500,
      stone: 200,
    },
    building_requirements: {},
    tech_requirements: ['teaching'],
  },
  aqueducts: {
    name: 'Aqueducts',
    desciption: 'Increase food production +5%',
    costs: {
      food: 1000,
      wood: 500,
      stone: 200,
    },
    building_requirements: {},
    tech_requirements: ['sculpture'],
  },
  iron_age: {
    name: 'Iron Age',
    desciption: 'Unlocks technology',
    costs: {
      food: 5000,
      wood: 500,
      stone: 300,
    },
    building_requirements: {},
    tech_requirements: ['aqueducts'],
  },
  metallurgy: {
    name: 'Metallurgy',
    desciption: 'Unlocks metal',
    costs: {
      wood: 300,
      stone: 300,
    },
    building_requirements: {},
    tech_requirements: ['iron_age'],
  },
  fortification: {
    name: 'Fortification',
    desciption: 'Increase population +2',
    costs: {
      stone: 300,
    },
    building_requirements: {},
    tech_requirements: ['iron_age'],
  },
  quarries: {
    name: 'Quarries',
    desciption: 'Increase stone / metal production +10%',
    costs: {
      food: 3000,
      wood: 300,
      metal: 50,
    },
    building_requirements: {},
    tech_requirements: ['metallurgy'],
  },
  strong_tools: {
    name: 'Strong tools',
    desciption: 'Increase stone / metal / wood production +5%',
    costs: {
      wood: 200,
      stone: 200,
      metal: 100,
    },
    building_requirements: {},
    tech_requirements: ['metallurgy'],
  },
  middle_age: {
    name: 'Middle ages',
    desciption: 'Unlocks middle ages',
    costs: {
      food: 7000,
      wood: 1500,
      stone: 1000,
      metal: 100,
    },
    building_requirements: {},
    tech_requirements: ['strong_tools', 'quarries', 'fortification'],
  },
  fertilization: {
    name: 'Fertilization',
    desciption: '+10% food',
    costs: {
      food: 3000,
      wood: 500,
      stone: 1000,
    },
    building_requirements: {},
    tech_requirements: ['middle_age'],
  },
  crop_rotation: {
    name: 'Crop rotation',
    desciption: '+5% food',
    costs: {
      food: 1500,
      metal: 100,
    },
    building_requirements: {},
    tech_requirements: ['fertilization'],
  },
  higher_education: {
    name: 'Higher education',
    desciption: '+2 population',
    costs: {
      stone: 1500,
      metal: 300,
    },
    building_requirements: {},
    tech_requirements: ['middle_age'],
  },
  medication: {
    name: 'Medication',
    desciption: '+2 population',
    costs: {
      food: 1500,
      wood: 1500,
      metal: 100,
    },
    building_requirements: {},
    tech_requirements: ['higher_education'],
  },
  chemistry: {
    name: 'Chemistry',
    desciption: 'Increase metal production +10%',
    costs: {
      wood: 1000,
      metal: 100,
    },
    building_requirements: {},
    tech_requirements: ['higher_education'],
  },
  gold_smith: {
    name: 'Gold smith',
    desciption: 'Unlocks gold smith',
    costs: {
      wood: 1500,
      stone: 1500,
      metal: 1000,
    },
    building_requirements: {},
    tech_requirements: ['chemistry'],
  },
  colonial_age: {
    name: 'Colonial Age',
    desciption: 'Unlocks new technology',
    costs: {
      food: 10000,
      wood: 2000,
      stone: 2000,
      metal: 200,
      gold: 100,
    },
    building_requirements: {},
    tech_requirements: ['gold_smith'],
  },
  cartography: {
    name: 'Cartography',
    desciption: 'Reduces exploration cost: -5%',
    costs: {
      food: 10000,
      wood: 500,
      stone: 200,
      metal: 200,
    },
    building_requirements: {},
    tech_requirements: ['colonial_age'],
  },
  maritime_trading: {
    name: 'Maritime Trading',
    desciption: 'Increase all production: +10%',
    costs: {
      food: 15000,
      wood: 1000,
      stone: 500,
      metal: 400,
      gold: 100,
    },
    building_requirements: {},
    tech_requirements: ['cartography'],
  },
  exploration: {
    name: 'Exploration',
    desciption: 'Decrease exploration cost by -5%',
    costs: {
      food: 5000,
      wood: 1500,
      metal: 200,
      gold: 50,
    },
    building_requirements: {},
    tech_requirements: ['cartography'],
  },
  colonies: {
    name: 'Colonies',
    desciption: 'Claim land (+10 acres) and increase population',
    costs: {
      wood: 1500,
      stone: 1500,
      metal: 200,
    },
    building_requirements: {},
    tech_requirements: ['exploration', 'maritime_trading'],
  },
  plantation: {
    name: 'Plantation',
    desciption: 'Increase food production +5%',
    costs: {
      food: 10000,
      wood: 750,
    },
    building_requirements: {},
    tech_requirements: ['colonies'],
  },
  trade_post: {
    name: 'Trade post',
    desciption: 'Increase gold production +10%',
    costs: {
      wood: 500,
      stone: 500,
      metal: 400,
      gold: 200,
    },
    building_requirements: {},
    tech_requirements: ['colonies'],
  },
  industrial_age: {
    name: 'Industrial Age',
    desciption: 'Unlock new technology',
    costs: {
      food: 12500,
      wood: 750,
      stone: 500,
      metal: 400,
      gold: 200,
    },
    building_requirements: {},
    tech_requirements: ['plantation', 'trade_post'],
  },
  factory: {
    name: 'Factory',
    desciption: 'Increase all production +10%',
    costs: {
      wood: 1000,
      stone: 1000,
      metal: 400,
      gold: 100,
    },
    building_requirements: {},
    tech_requirements: ['industrial_age'],
  },
  railroads: {
    name: 'Railroads',
    desciption: 'Decrease exploration costs -5%',
    costs: {
      food: 10000,
      metal: 400,
      gold: 200,
    },
    building_requirements: {},
    tech_requirements: ['factory'],
  },
  workers_houses: {
    name: 'Workers houses',
    desciption: 'Increase population +2',
    costs: {
      wood: 1000,
      stone: 500,
    },
    building_requirements: {},
    tech_requirements: ['industrial_age'],
  },
  explosives: {
    name: 'Explosives',
    desciption: 'Increase gold and metal production +10%',
    costs: {
      food: 2500,
      wood: 750,
      metal: 100,
      gold: 50,
    },
    building_requirements: {},
    tech_requirements: ['industrial_age'],
  },
  progressive_era: {
    name: 'Progressive Era',
    desciption: 'Unlocks technology',
    costs: {
      food: 20000,
      wood: 1750,
      stone: 1000,
      metal: 700,
      gold: 400,
    },
    building_requirements: {},
    tech_requirements: ['explosives', 'workers_houses', 'railroads'],
  },
  electricity: {
    name: 'Electricity',
    desciption: 'Unlocks technology',
    costs: {
      metal: 700,
      gold: 400,
    },
    building_requirements: {},
    tech_requirements: ['progressive_era'],
  },
  high_rise: {
    name: 'High Rise',
    desciption: '+25% population',
    costs: {
      food: 20000,
      wood: 1750,
      stone: 1000,
    },
    building_requirements: {},
    tech_requirements: ['progressive_era'],
  },
  automobiles: {
    name: 'Automobiles',
    desciption: 'Gain +5 acres',
    costs: {
      gold: 100,
    },
    building_requirements: {},
    tech_requirements: ['progressive_era'],
  },
  power_plants: {
    name: 'Power Plants',
    desciption: 'Produce power',
    costs: {
      food: 10000,
      wood: 1000,
      stone: 2000,
      metal: 500,
      gold: 50,
    },
    building_requirements: {},
    tech_requirements: ['electricity'],
  },
  flight: {
    name: 'Flight',
    desciption: 'Reduce exploration costs -10%',
    costs: {
      wood: 1000,
      metal: 1000,
      gold: 400,
    },
    building_requirements: {},
    tech_requirements: ['automobiles', 'power_plants'],
  },
  mass_production: {
    name: 'Mass production',
    desciption: 'Increase all production +10%',
    costs: {
      food: 10000,
      wood: 1000,
      stone: 2000,
      metal: 1000,
      gold: 500,
    },
    building_requirements: {},
    tech_requirements: ['power_plants', 'automobiles'],
  },
  capitalism: {
    name: 'Capitalism',
    desciption: 'Increase gold +10%',
    costs: {
      food: 10000,
      metal: 1000,
      gold: 100,
    },
    building_requirements: {},
    tech_requirements: ['mass_production'],
  },
  contemporary_era: {
    name: 'Contemporary era',
    desciption: 'New tech',
    costs: {
      food: 40000,
      metal: 3000,
      gold: 2000,
    },
    building_requirements: {
      power_plants: 10
    },
    tech_requirements: ['capitalism'],
  },
  electronics: {
    name: 'Electronics',
    desciption: 'Unlocks tech',
    costs: {
      food: 30000,
      wood: 10000,
      metal: 2000,
      gold: 2000,
    },
    building_requirements: {},
    tech_requirements: ['contemporary_era'],
  },
  space_flight: {
    name: 'Space flight',
    desciption: 'Exploration cost -5%',
    costs: {
      food: 10000,
      stone: 10000,
      metal: 1000,
      gold: 1000,
    },
    building_requirements: {},
    tech_requirements: ['electronics'],
  },
  internet: {
    name: 'Internet',
    desciption: 'Increase population',
    costs: {
      food: 10000,
      metal: 1000,
      gold: 2000,
    },
    building_requirements: {},
    tech_requirements: ['electronics'],
  },
  cloud: {
    name: 'Cloud',
    desciption: 'Unlocks Data Centers',
    costs: {
      food: 40000,
      wood: 7500,
      stone: 5000,
      metal: 2000,
      gold: 2000,
    },
    building_requirements: {},
    tech_requirements: ['internet'],
  },
  automation: {
    name: 'Automation',
    desciption: 'Metal / Gold production +10%',
    costs: {
      food: 40000,
      wood: 20000,
      stone: 15000,
      metal: 5000,
    },
    building_requirements: {},
    tech_requirements: ['contemporary_era'],
  },
  mega_farms: {
    name: 'Mega farms',
    desciption: 'Food production +10%',
    costs: {
      food: 40000,
      wood: 5000,
      stone: 2500,
    },
    building_requirements: {},
    tech_requirements: ['automation'],
  },
  renewable_energy: {
    name: 'Renewable energy',
    desciption: 'Increase power efficiency by 5%',
    costs: {
      food: 40000,
      wood: 10000,
      stone: 5000,
      metal: 5000,
      gold: 2000,
      data: 1,
    },
    building_requirements: {
      datacenter: 1,
    },
    tech_requirements: ['electronics', 'cloud'],
  },
  tomorrow: {
    name: 'Tomorrow',
    desciption: 'Unlocks new age',
    costs: {
      food: 300000,
      wood: 50000,
      stone: 45000,
      metal: 30000,
      gold: 15000,
      power: 500,
      data: 10,
    },
    building_requirements: {
      datacenter: 10,
    },
    tech_requirements: ['renewable_energy', 'mega_farms', 'internet', 'space_flight'],
  },
  fusion_energy: {
    name: 'Fusion energy',
    desciption: 'Increase power efficiency and output',
    costs: {
      food: 1000000,
      wood: 15000,
      stone: 10000,
      metal: 10000,
      gold: 5000,
      power: 500,
      data: 15,
    },
    building_requirements: {
      powerplant: 10,
    },
    tech_requirements: ['tomorrow'],
  },
  quantum_computers: {
    name: 'Quantum computers',
    desciption: 'Increase data generation',
    costs: {
      metal: 50000,
      gold: 10000,
      data: 50,
    },
    building_requirements: {},
    tech_requirements: ['tomorrow'],
  },
  recycle: {
    name: 'Recycle',
    desciption: 'Increase metal and gold production +10%',
    costs: {
      food: 40000,
      wood: 50000,
      stone: 30000,
      data: 50,
    },
    building_requirements: {},
    tech_requirements: ['tomorrow'],
  },
  arcology: {
    name: 'Arcology',
    desciption: 'Increase population and food production',
    costs: {
      food: 100000,
      wood: 10000,
      stone: 10000,
      metal: 10000,
      gold: 5000,
      data: 50,
    },
    building_requirements: {},
    tech_requirements: ['fusion_energy', 'recycle'],
  },
  moon_base: {
    name: 'Moon base',
    desciption: 'Get 20 land and increase population',
    costs: {
      food: 100000,
      wood: 10000,
      stone: 10000,
      metal: 20000,
      gold: 10000,
      data: 50,
    },
    building_requirements: {},
    tech_requirements: ['tomorrow'],
  },
  mars_base: {
    name: 'Mars base',
    desciption: 'Get 30 land and increase population',
    costs: {
      food: 200000,
      wood: 20000,
      stone: 20000,
      metal: 20000,
      gold: 10000,
      data: 100,
    },
    building_requirements: {},
    tech_requirements: ['moon_base', 'arcology'],
  },
  deep_space_age: {
    name: 'Deep space age',
    desciption: 'Unlock deep space age',
    costs: {
      food: 500000,
      wood: 80000,
      stone: 80000,
      metal: 75000,
      gold: 20000,
      power: 1000,
      data: 300,
    },
    building_requirements: {},
    tech_requirements: ['mars_base', 'quantum_computers', ],
  },
  quantum_network: {
    name: 'Quantum network',
    desciption: 'Increase data generation',
    costs: {
      food: 500000,
      metal: 40000,
      gold: 20000,
      data: 750,
    },
    building_requirements: {},
    tech_requirements: ['deep_space_age'],
  },
  space_base: {
    name: 'Space base',
    desciption: 'Free acres and population',
    costs: {
      food: 500000,
      wood: 20000,
      stone: 20000,
      metal: 60000,
      gold: 20000,
      data: 300,
    },
    building_requirements: {},
    tech_requirements: ['deep_space_age'],
  },
  terraforming: {
    name: 'Terraforming',
    desciption: 'Free acres and population',
    costs: {
      food: 1000000,
      wood: 100000,
      stone: 100000,
      metal: 40000,
      gold: 40000,
      data: 1000,
    },
    building_requirements: {},
    tech_requirements: ['space_base'],
  },
  warp_drive: {
    name: 'Warp drive',
    desciption: 'Increase data generation +10%',
    costs: {
      food: 500000,
      wood: 40000,
      stone: 40000,
      metal: 50000,
      gold: 20000,
      data: 600,
    },
    building_requirements: {},
    tech_requirements: ['deep_space_age'],
  },
  deep_space_travel: {
    name: 'Deep space travel',
    desciption: 'Reduce exploration',
    costs: {
      data: 750,
    },
    building_requirements: {},
    tech_requirements: ['warp_drive', 'quantum_network'],
  },
  dimensional_era: {
    name: 'Dimensional era',
    desciption: 'Unlock new tech',
    costs: {
      food: 2000000,
      wood: 200000,
      stone: 150000,
      metal: 150000,
      gold: 100000,
      data: 1500,
    },
    building_requirements: {},
    tech_requirements: ['deep_space_travel'],
  },
  star_gate: {
    name: 'Star gate',
    desciption: 'Reduce exporation costs -10%',
    costs: {
      metal: 75000,
      gold: 50000,
      data: 1000,
    },
    building_requirements: {},
    tech_requirements: ['dimensional_era'],
  },
  matter_generation: {
    name: 'Matter generation',
    desciption: 'Increase production +15%',
    costs: {
      food: 1500000,
      wood: 100000,
      stone: 100000,
      metal: 50000,
      gold: 20000,
      data: 1500,
    },
    building_requirements: {},
    tech_requirements: ['dimensional_era', 'terraforming'],
  },
  zero_point_energy: {
    name: 'Zero point energy',
    desciption: 'Increase power efficiency and generation',
    costs: {
      food: 1500000,
      wood: 100000,
      stone: 100000,
      metal: 50000,
      gold: 20000,
      data: 1500,
    },
    building_requirements: {},
    tech_requirements: ['dimensional_era'],
  },
  dimensional_science: {
    name: 'Dimensional science',
    desciption: 'Unlock ascension and increase data generation',
    costs: {
      food: 3000000,
      wood: 300000,
      stone: 200000,
      metal: 200000,
      gold: 200000,
      data: 2000,
    },
    building_requirements: {},
    tech_requirements: ['zero_point_energy', 'matter_generation', 'star_gate'],
  },
  ascension: {
    name: 'Ascension',
    desciption: 'Ascend',
    costs: {
      data: 10000,
    },
    building_requirements: {},
    tech_requirements: ['dimensional_science'],
  },
};

export const ASCENSION = {
  time_distortion: {
    name: 'Time distortion',
    description: 'Bends the time space to increase production based on the amount of ascensions (+25% / ascension)',
    costs: 1,
    ascension_requirements: [],
  },
  ascension_knowledge: {
    name: 'Ascension knowledge',
    description: 'Gain an extra ascension point each ascension.',
    costs: 1,
    ascension_requirements: ['time_distortion'],
  },
  thoughtless_thoughts: {
    name: 'Thoughtless thoughts',
    description: 'Gain 10% of your income when offline. After 8 hours this is reduced by 90%.',
    costs: 1,
    ascension_requirements: ['time_distortion'],
  },
  remembering_thoughts: {
    name: 'Remembering thoughts',
    description: 'Gain 25% of your income when offline.',
    costs: 20,
    ascension_requirements: ['thoughtless_thoughts'],
  },
  understanding_thoughts: {
    name: 'Understanding thoughts',
    description: 'Gain 40% of your income when offline.',
    costs: 100,
    ascension_requirements: ['remembering_thoughts'],
  },
  applying_thoughts: {
    name: 'Applying thoughts',
    description: 'Gain 50% of your income when offline.',
    costs: 1000,
    ascension_requirements: ['understanding_thoughts'],
  },
  analysing_thoughts: {
    name: 'Analysing thoughts',
    description: 'Gain 60% of your income when offline.',
    costs: 1000,
    ascension_requirements: ['applying_thoughts'],
  },
  evaluating_thoughts: {
    name: 'Evaluating thoughts',
    description: 'Gain 70% of your income when offline.',
    costs: 10000,
    ascension_requirements: ['analysing_thoughts'],
  },
  creating_thoughts: {
    name: 'Creating thoughts',
    description: 'Gain 80% of your income when offline.',
    costs: 100000,
    ascension_requirements: ['evaluating_thoughts'],
  },
  fifth_dimension: {
    name: 'Fifth dimension',
    description: 'By accessing the 5th dimension and knowing the manipulation of time your reincarnation',
    costs: 10,
    ascension_requirements: ['ascension_knowledge', 'blaat'],
  },
  berry_bush: {
    name: 'Berry bush',
    description: 'Start the game with additional food',
    costs: 1,
    ascension_requirements: ['time_distortion'],
  },
  firewood: {
    name: 'Firewood',
    description: 'Start the game with additional wood',
    costs: 1,
    ascension_requirements: ['time_distortion'],
  },
  stone_pile: {
    name: 'Stone pile',
    description: 'Start the game with additional stone',
    costs: 5,
    ascension_requirements: ['berry_bush', 'firewood'],
  },
};

export const TECH_STATE = {
  // Stone age
  stone_age: false,
  cultivation: false,
  growing: false,
  agriculture: false,
  tools: false,
  woodwork: false,
  wheel: false,
  wheelbarrow: false,
  // Bronze age
  bronze_age: false,
  irrigation: false,
  masonry: false,
  brick_house: false,
  paths: false,
  smelting: false,
  // Roman age
  roman_age: false,
  stone_roads: false,
  teaching: false,
  philosophy: false,
  sculpture: false,
  aqueducts: false,
  // Iron Age
  iron_age: false,
  metallurgy: false,
  fortification: false,
  quarries: false,
  strong_tools: false,
  // Middle ages
  middle_age: false,
  crop_rotation: false,
  fertilization: false,
  higher_education: false,
  medication: false,
  chemistry: false,
  gold_smith: false,
  // colonial
  colonial_age: false,
  cartography: false,
  maritime_trading: false,
  exploration: false,
  colonies: false,
  plantation: false,
  trade_post: false,

  // industrial age
  industrial_age: false,
  factory: false,
  railroads: false,
  workers_houses: false,
  explosives: false,

  // progressive era
  progressive_era: false,
  electricity: false,
  high_rise: false,
  automobiles: false,
  flight: false,
  power_plants: false,
  mass_production: false,
  capitalism: false,

  // contemporary era
  contemporary_era: false,
  electronics: false,
  space_flight: false,
  internet: false,
  cloud: false,
  automation: false,
  mega_farms: false,
  renewable_energy: false,

  // Tomorrow
  tomorrow: false,
  fusion_energy: false,
  arcology: false,
  quantum_computers: false,
  recycle: false,
  moon_base: false,
  mars_base: false,

  // Deep space
  deep_space_age: false,
  terraforming: false,
  space_base: false,
  deep_space_travel: false,
  quantum_network: false,

  // Dimensional
  dimensional_era: false,
  zero_point_energy: false,
  dimensional_science: false,
  ascension: false,
};

export const AGE_BONUS = 0.05;

export let SINGLETON_TECH = {
  STATE: TECH_STATE
};

export const ASCENSION_STATE = {
  isAscending: false,
  ascension_points: 0,
  total_ascension_points: 0,
  times_ascended:   0,
  ascension_level:   0,
  unlocked: {
    time_distortion: false,
    ascension_knowledge: false,
    fifth_dimension: false,
    thoughtless_thoughts: false,
    remembering_thoughts: false,
    understanding_thoughts: false,
    applying_thoughts: false,
    analysing_thoughts: false,
    evaluating_thoughts: false,
    creating_thoughts: false,
    berry_bush: false,
    firewood: false,
    stone_pile: false,
  }
};

export let SINGLETON_ASCENSION = {
  STATE: ASCENSION_STATE
};

export const AGES = {
  stone: 1,
  bronze: 1,
  roman: 1,
  iron: 1,
  middelage: 1,
  colonial: 1,
  industrial: 1,
  progressive: 1,
  contemporary: 1,
  tomorrow: 1,
  future: 1,
  deepspace: 1,
  dimensional: 1,
};
